<template>
  <InternationalPublishingStatusTable
    v-bind="{ ...$props, ...$attrs }"
    :default-language="defaultLanguage"
    :languages="languagesToInclude"
    :online-status-text="onlineStatusText"
  />
</template>

<script setup lang="ts">
import InternationalPublishingStatusTable from 'src/app/components/publishing/InternationalPublishingStatusTable.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useCompositionStore } from 'commons/stores/composition';

const props = defineProps<{
  getDeeplinkForLocale: () => any;
  requestDeeplinkForPendingTranslations?: boolean;
  displayNoneExistingTranslations?: boolean;
  displayUnavailableDeeplinks?: boolean;
  isInstantlyPublished?: boolean;
}>();

const store = useStore();
const compositionStore = useCompositionStore();
const languages = computed(() => store.state.platform.languages);
const composition = computed(() => compositionStore.current);

const requestedAutotranslations = computed(
  () => composition.value.metaData.autoTranslate,
);
const defaultLanguage = computed(
  () => composition.value.metaData.originLanguageCode,
);
const intPubRejected = computed(() => false); // TODO this.composition.metaData.intPub
const onlineStatusText = props.isInstantlyPublished
  ? 'DESIGNS.STATUS.ONLINE_FIRST'
  : 'DESIGNS.STATUS.PUBLISHED';

const languagesToInclude = languages.value
  .filter((language) => {
    if (
      props.displayNoneExistingTranslations ||
      (requestedAutotranslations.value &&
        !intPubRejected.value &&
        !composition.value.publishingDetails.d2c.locales.length)
    ) {
      return true;
    } else {
      // TODO: Shop case?
      return (
        composition.value.publishingDetails.d2c.locales.includes(
          language.isoCode,
        ) || language.isoCode === defaultLanguage.value
      );
    }
  })
  .map((language) => ({
    ...language,
    pending: !composition.value.metaData.name.find(
      (translation) => translation.language === language.isoCode,
    ),
  }));
</script>
